module.exports = __webpack_public_path__ + "static/media/nielsen_meet_matt.a7412635.png";